import { Scenario, Category } from '../types';

export const groupScenariosByCategory = (scenarios: Scenario[]): Category[] => {
  const categoriesMap = new Map<string, Scenario[]>();

  scenarios.forEach(scenario => {
    const category = scenario['Kategoria'];
    if (!categoriesMap.has(category)) {
      categoriesMap.set(category, []);
    }
    categoriesMap.get(category)?.push(scenario);
  });

  return Array.from(categoriesMap.entries()).map(([name, scenarios]) => ({
    name,
    scenarios: scenarios.map(scenario => ({
      ...scenario,
      Status: scenario.Status || 'Not Tested',
      Notes: scenario.Notes || ''
    }))
  }));
};

export const generateUniqueId = (): string => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `${timestamp}_${random}`;
};

export const extractCategories = (scenarios: Scenario[]): string[] => {
  const uniqueCategories = new Set<string>();
  scenarios.forEach(scenario => {
    if (scenario['Kategoria']) {
      uniqueCategories.add(scenario['Kategoria']);
    }
  });
  return Array.from(uniqueCategories).sort();
};
